import { render, staticRenderFns } from "./EditEducationQuestions.vue?vue&type=template&id=32a02be0&"
import script from "./EditEducationQuestions.vue?vue&type=script&lang=js&"
export * from "./EditEducationQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports